import { createFileRoute, useParams, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { ThematicDefinitionEditor } from '../../../../components/thematics/ThematicDefinitionEditor'

// `saved` is set by the redirect that follows the creation of a thematic, so
// the new page can still say it was saved.
const searchSchema = z.object({
  saved: z.union([z.boolean(), z.number(), z.string()]).optional().transform((v) => v === true || v === 1 || v === '1' || v === 'true').catch(false),
})

export const Route = createFileRoute('/$org/types/thematics/$code')({
  validateSearch: searchSchema,
  component: ThematicEditorRoute,
})

function ThematicEditorRoute() {
  const { org, code } = useParams({ from: '/$org/types/thematics/$code' })
  const { saved } = useSearch({ from: '/$org/types/thematics/$code' })
  // Keyed by code so moving from one definition to another resets the draft.
  return <ThematicDefinitionEditor key={code} org={org} code={code} justSaved={saved} />
}
